import { HelpText } from '@components/DataForm'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Link } from '@mui/material'
import { useTranslation } from 'react-i18next'

const NEED_HELP_STYLE = {
	margin: 0,
	height: '20px',
}

export const NeedHelp = () => {
	const { t } = useTranslation()

	return (
		<HelpText style={NEED_HELP_STYLE}>
			<Link
				href="mailto:support@co2ai.com"
				display="flex"
				alignItems="center"
				gap={0.5}
			>
				<OpenInNewIcon fontSize="small" />
				{t('corporateData.needHelp')}
			</Link>
		</HelpText>
	)
}
